import { ShieldCheck } from "lucide-react";

/**
 * Compact independent-coordination strip used on service pages.
 * Deliberately smaller than IndependenceStrip so it doesn't visually dominate.
 */
export const SafetyStrip = ({ className = "" }) => (
  <div
    data-testid="safety-strip"
    className={`flex items-start gap-3 rounded-xl border border-[hsl(var(--vc-line))] bg-mint px-4 py-3 ${className}`}
  >
    <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-brand text-white">
      <ShieldCheck className="h-4 w-4" />
    </span>
    <div className="text-sm leading-relaxed text-[hsl(var(--vc-ink))]">
      <p className="font-bold">Independent healthcare coordination</p>
      <p className="mt-1 text-[hsl(var(--vc-slate))]">
        Doctors Vietnam helps coordinate access to independent licensed healthcare providers.
        We are not a hospital, clinic, ambulance service or emergency department, and we do not
        diagnose or provide medical treatment. Medical decisions and treatment are made by the
        treating healthcare professional.
      </p>
    </div>
  </div>
);

export default SafetyStrip;
